<template>
  <v-card class="card-container">
    <v-dialog v-model="dialog" :key="dialogKey" max-width="500">
      <Manage
        :solutionProp="solution"
        @close="dialog = false"
        @confirm="list(), (dialog = false)"
      />
    </v-dialog>

    <div class="main-toolbar mb-2">
      <div class="icon-back">
        <v-icon color="white" size="27">mdi-auto-fix</v-icon>
      </div>

      <span class="main-toolbar-title">{{ $t('Soluções defeito') }}</span>

      <v-spacer></v-spacer>

      <v-btn
        class="secondary-button mt-2"
        depressed
        @click=";(solution = {}), (dialogKey = !dialogKey), (dialog = true)"
      >
        {{ $t('Nova Solução') }}
      </v-btn>
      <v-btn class="primary-button mr-0" depressed @click="show = !show">
        {{ show ? $t('Fechar') : 'Filtros' }}
      </v-btn>
    </div>

    <v-expand-transition>
      <div v-show="show" class="mb-2">
        <v-form ref="form">
          <v-row class="ma-0" align="center" dense>
            <v-col>
              <span class="text ml-1">{{ $t('Solução') }}</span>
              <v-text-field
                class="primary-input"
                :placeholder="$t('Pesquisar por solução')"
                v-model="filter.solution"
                outlined
                hide-details="auto"
              >
              </v-text-field>
            </v-col>

            <v-col>
              <span class="text ml-1">{{ $t('Oficina') }}</span>
              <v-autocomplete
                :items="workshops"
                :loading="workshopsLoading"
                item-text="name"
                item-value="id"
                v-model="filter.workshopId"
                append-icon="mdi-chevron-down"
                class="primary-input"
                :placeholder="$t('Pesquisar por oficina')"
                outlined
                hide-details="auto"
              >
                <template v-slot:item="{ item }">
                  <span class="text-caption">
                    {{ item.name }}
                  </span>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <div class="d-flex justify-end">
            <v-btn class="clear-button" depressed @click="reset">
              {{ $t('Limpar') }}
            </v-btn>
            <v-btn @click="applyFilter" class="secondary-button mr-0" depressed>
              {{ $t('Aplicar filtros') }}
            </v-btn>
          </div>
        </v-form>
      </div>
    </v-expand-transition>

    <v-data-table
      :headers="headers"
      :items="solutions"
      :items-per-page="filter.pageSize"
      class="main-table"
      hide-default-header
      :loading-text="$t('Carregando...')"
      :no-data-text="$t('Nenhuma solução encontrada')"
      hide-default-footer
      mobile-breakpoint="0"
    >
      <template #header="{ props, on }">
        <thead>
          <tr>
            <th
              class="text-center"
              v-for="header in props.headers"
              :key="header.value"
            >
              <v-simple-checkbox
                v-if="header.value === 'data-table-select'"
                v-model="props.everyItem"
                :indeterminate="props.someItems && !props.everyItem"
                color="purple"
                @input="on['toggle-select-all']"
              ></v-simple-checkbox>

              <div>
                <v-hover v-slot="{ hover }">
                  <div>
                    <span>{{ $t(header.text) }}</span>
                    <v-icon
                      v-if="
                        hover &&
                        header.value != 'data-table-select' &&
                        header.value != 'actions'
                      "
                      color="white"
                      class="mx-2"
                      @click="on.sort(header.value)"
                    >
                      {{
                        props.options.sortBy.includes(header.value)
                          ? `mdi-chevron-down`
                          : `mdi-chevron-up`
                      }}
                    </v-icon>
                  </div>
                </v-hover>
              </div>
            </th>
          </tr>
        </thead>
      </template>

      <template #[`item.workshops`]="{ item }">
        <span>
          {{
            item.workshops && item.workshops.length > 0
              ? item.workshops.map((x) => x.workshop.name).join(',')
              : 'Engenharia Clínica'
          }}
        </span>
      </template>

      <template #[`item.createdAt`]="{ item }">
        <span> {{ formatDate(item.createdAt) }} </span>
      </template>

      <template #[`item.updatedAt`]="{ item }">
        <span> {{ formatDate(item.updatedAt) }} </span>
      </template>

      <template #[`item.actions`]="{ item }">
        <v-tooltip bottom>
          <template #activator="{ on }">
            <v-btn
              class="ma-1"
              color="#0F3565"
              dark
              small
              depressed
              @click="
                ;(solution = item), (dialogKey = !dialogKey), (dialog = true)
              "
              v-on="on"
            >
              <v-icon size="22">mdi-pencil-outline</v-icon>
            </v-btn>
          </template>
          <span>Editar</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <div class="pagination block-two">
      <div class="item-pagination block-one">
        <div class="registros" v-if="solutions.length">
          <v-menu bottom offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                class="btn"
                depressed
                color="#C0C0C0"
                small
              >
                qtd: {{ filter.pageSize }}
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                v-for="(size, i) in sizes"
                :key="i"
                @click="updatePageSize(size)"
              >
                <v-list-item-title>{{ size }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <span> 1 - {{ solutions.length }} de {{ filter.totalItems }} </span>
          <br />
        </div>
      </div>
      <div class="item-pagination block-two">
        <v-pagination
          class="pagination-item"
          v-model="filter.page"
          :length="filter.totalPages"
          :total-visible="5"
        ></v-pagination>
      </div>
    </div>
  </v-card>
</template>

<script>
import Manage from './manage.vue'
import FormatDate from '../../../Utils/FormatDate'
import ApiService from '../../../services/ApiService'

export default {
  name: 'SolutionsPage',

  created() {
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.filter.institutionId = this.institution.id
    this.list()
    this.getWorkshops()
  },

  components: {
    Manage,
  },

  data() {
    return {
      workshops: [],
      workshopsLoading: false,
      apiService: new ApiService(),
      show: false,
      sizes: [10, 30, 90, 180],
      page: 1,
      filter: {
        page: 1,
        pageSize: 10,
      },
      solutions: [],
      solution: {},
      dialog: false,
      dialogKey: false,
      headers: [
        {
          text: '',
          align: 'center',
          value: '',
        },
        {
          text: 'Solução',
          align: 'center',
          value: 'solution',
        },
        {
          text: 'Oficina',

          align: 'center',
          value: 'workshops',
        },
        {
          text: 'Data de criação',

          align: 'center',
          value: 'createdAt',
        },
        {
          text: 'Última atualização',

          align: 'center',
          value: 'updatedAt',
        },
        {
          text: '',
          align: 'center',
          value: 'actions',
          sortable: false,
        },
      ],
      types: [
        { text: 'Engenharia Clínica', value: 0 },
        { text: 'Carpintaria', value: 1 },
        { text: 'Elétrica', value: 2 },
        { text: 'Hidráulica', value: 3 },
        { text: 'Climatização', value: 4 },
        { text: 'Gasoterapia', value: 5 },
        { text: 'Zeladoria', value: 6 },
        { text: 'Vidraçaria', value: 7 },
        { text: 'Mecânica', value: 8 },
        { text: 'Serralheria', value: 9 },
        { text: 'Predial Civil', value: 10 },
        { text: 'Pintura Predial', value: 11 },
        { text: 'Pintura Industrial', value: 12 },
      ],
    }
  },

  methods: {
    removeWorkshop(item) {
      this.filter.workshops.splice(this.filter.workshops.indexOf(item), 1)
      this.filter.workshops = [...this.filter.workshops]
    },

    async getWorkshops() {
      try {
        this.workshopsLoading = true
        const response = await this.apiService.get(
          `workshop/${this.institution.id}`
        )
        this.workshops = response.content
        this.workshopsLoading = false
      } catch (error) {
        console.error('Erro ao buscar workshops:', error)
        this.workshopsLoading = false
      } finally {
        this.workshopsLoading = false
      }
    },

    reset() {
      this.filter.page = 1
      this.filter.solution = ''
      this.filter.workshopType = ''
      this.list()
    },

    formatDate(date) {
      return FormatDate.dateTime(date)
    },

    applyFilter() {
      this.list()
    },

    list() {
      this.apiService
        .post('defectSolution/list/paginate', this.filter)
        .then((response) => {
          this.solutions = response.content.entities

          const pager = response.content.pager
          this.filter.page = pager.currentPage
          this.filter.pageSize = pager.pageSize
          this.filter.totalItems = pager.totalItems
          this.filter.totalPages = pager.totalPages
        })
      },
      updatePageSize(size) {
        this.filter.page = 1
        this.filter.pageSize = size
        this.list()
      },
      
  },

  watch: {
    'filter.page': {
      deep: true,
      handler() {
        this.list()
      },
    },
  },
}
</script>

<style scoped lang="scss"></style>
